import { Application } from '@pixi/app';
import { Assets } from "@pixi/assets";
import { Ticker } from 'pixi.js';

export class Game extends Application {
    public constructor() {
        super({
            backgroundColor: 0xffffff,
            backgroundAlpha: 1.0,
            width: window.innerWidth,
            height: window.innerHeight,
            antialias: true,
            clearBeforeRender: false,
            autoDensity: true,
            resolution: window.devicePixelRatio
        });
        Ticker.shared.autoStart = false;
    }

    public async launch(manifestPath: string): Promise<void> {
        const manifest = await (await fetch(manifestPath)).json();
        await Assets.init({ manifest });
    }
}